// avoiding package root import to avoid circular dependency
// eslint-disable-next-line monorepo/no-internal-import
import {Locale} from '@aboutyou/config/src/locale';
import pathToRegexp from 'path-to-regexp';
import {getPageTypePathsMap_UNSAFE, PageTypePathMap} from './route.paths';
import {PageTypes} from './types';

export const getCurrentRouteFromUrl = (
  locale: Locale,
  url: string,
): PageTypes | undefined => {
  // eslint-disable-next-line no-restricted-syntax
  const pageTypePathsMap: PageTypePathMap = getPageTypePathsMap_UNSAFE({
    locale,
  });

  return getPageType(pageTypePathsMap, url);
};

const regExpCache = new Map<string, RegExp>();
export const getPageType = (pageTypePathsMap: PageTypePathMap, url: string) => {
  const pathname = url.split('?')[0];
  if (!pathname) {
    return undefined;
  }
  for (const [key, value] of Object.entries(pageTypePathsMap)) {
    const path = (value as string[]).find(regexp => {
      if (regexp === pathname) {
        return true;
      }
      let expression = regExpCache.get(regexp);
      if (!expression) {
        expression = pathToRegexp(regexp);
        regExpCache.set(regexp, expression);
      }

      return Boolean(expression.test(pathname));
    });

    if (path) {
      return key as PageTypes;
    }
  }

  return undefined;
};
